import { render, staticRenderFns } from "./addPrivilegeView.vue?vue&type=template&id=534e0256&scoped=true"
import script from "./addPrivilegeView.vue?vue&type=script&lang=js"
export * from "./addPrivilegeView.vue?vue&type=script&lang=js"
import style0 from "./addPrivilegeView.vue?vue&type=style&index=0&id=534e0256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e0256",
  null
  
)

export default component.exports